import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { CardHeaderComponent } from './card-header.component';
import { initialsOf } from '../../../shared/utils/employee-name.util';

export interface BirthdayEmployee {
  id: string;
  name: string;
  designation: string;
  birthday: string;
  avatar?: string;
}

@Component({
  selector: 'app-upcoming-birthdays-tile',
  standalone: true,
  imports: [CardHeaderComponent],
  template:`<div
  class="card flex h-full flex-col rounded-xl border border-surface-200/60 bg-surface-0 p-5 dark:border-surface-700/40 dark:bg-surface-900"
>
  <app-card-header
    [title]="title()"
    [subtitle]="subtitle()"
    [icon]="icon()"
    [accent]="accent()"
  />

  @if (loading()) {

    <div class="mt-4 space-y-3">

      @for(i of [1,2,3]; track i){

        <div class="flex items-center gap-3 animate-pulse">

          <div class="h-10 w-10 rounded-full bg-surface-200 dark:bg-surface-700"></div>

          <div class="flex-1 space-y-2">

            <div class="h-3 w-32 rounded bg-surface-200 dark:bg-surface-700"></div>

            <div class="h-2 w-24 rounded bg-surface-200 dark:bg-surface-700"></div>

          </div>

        </div>

      }

    </div>

  } @else if (birthdays().length) {

    <!-- <a
      [routerLink]="link()"
      class="mt-4 flex flex-col divide-y divide-surface-200 dark:divide-surface-700"
    > -->

      @for(employee of birthdays(); track employee.id){

        <div
          class="flex items-center gap-3 py-3 transition-colors hover:bg-surface-50 dark:hover:bg-surface-800 rounded-lg px-2"
        >

          @if(employee.avatar){

            <img
              [src]="employee.avatar"
              class="h-10 w-10 rounded-full object-cover"
            />

          } @else {

            <div
              class="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 font-semibold text-primary-700 dark:bg-primary-900 dark:text-primary-200"
            >
              {{ initials(employee.name) }}
            </div>

          }

          <div class="min-w-0 flex-1">

            <div class="truncate font-medium text-text-main">
              {{ employee.name }}
            </div>

            <div class="truncate text-xs text-text-muted">
              {{ employee.designation }}
            </div>

          </div>

          <div
            class="rounded-full bg-pink-100 px-2 py-1 text-xs font-semibold text-pink-700 dark:bg-pink-900/40 dark:text-pink-300"
          >
            {{ employee.birthday }}
          </div>

        </div>

      }

    <!-- </a> -->

  } @else {

    <div class="flex flex-1 items-center justify-center text-sm text-text-muted">
      No upcoming birthdays
    </div>

  }
</div>`,
})
export class UpcomingBirthdaysTileComponent {
  title = input.required<string>();
  subtitle = input<string>('');
  icon = input<string>('pi pi-gift');
  accent = input<string>('pink');

  birthdays = input<BirthdayEmployee[]>([]);
  loading = input(false);

  // link = input<string | any[]>('/employees');

  readonly initials = initialsOf;
}